import { ReactElement } from 'react'

import 'app/styles/components/Button.css'

interface Props {
  variant: 'primary' | 'secondary'
  children: ReactElement | string | string[]
  loading?: boolean
  disabled?: boolean
  className?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const Button = ({
  variant,
  children,
  loading = false,
  disabled = false,
  className,
  onClick,
}: Props) => (
  <button
    className={`py-2.5 px-6 rounded-button body-p-small text-sm ${
      variant === 'primary'
        ? 'bg-blue text-white'
        : 'bg-transparent text-blue border border-blue'
    } ${className} ${disabled && 'bg-gray-300 cursor-default'}`}
    onClick={(event) => {
      if (loading || disabled) {
        event.preventDefault()
      } else {
        onClick && onClick(event)
      }
    }}
  >
    {loading ? <div className='loader'></div> : children}
  </button>
)

export default Button
